import { Button, ConfigContext } from "@pionex-web-kit/components";
import React, { useContext } from "react";
import { useTranslators } from "../hooks/Locale";
import { HelpCenterPage } from "./types";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SignGuide = function SignGuide(_ref) {
  var navigate = _ref.navigate,
    close = _ref.close,
    onSign = _ref.onSign;
  var _useTranslators = useTranslators(),
    $st = _useTranslators.$st;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls("helpCenter-sign");
  return /*#__PURE__*/_jsxs("div", {
    className: prefixCls,
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "".concat(prefixCls, "-title"),
        children: $st("zendesk_sign_title")
      }), /*#__PURE__*/_jsx("div", {
        className: "".concat(prefixCls, "-desc"),
        children: $st("zendesk_sign_desc")
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(prefixCls, "-action"),
      children: [/*#__PURE__*/_jsx(Button, {
        type: "primary",
        size: "large",
        onClick: function onClick() {
          close === null || close === void 0 ? void 0 : close();
          onSign();
        },
        children: $st("zendesk_sign_button")
      }), /*#__PURE__*/_jsx(Button, {
        size: "large",
        onClick: function onClick() {
          return navigate(HelpCenterPage.contact);
        },
        children: $st("zendesk_visitor_button")
      })]
    })]
  });
};